exports.baseURL = "https://admin.egchat.live/";
exports.key = "8{vWkyP/zyJne9s";
